import React, { useState , useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  InputGroupAddon,
  InputGroup,
  Input,
  ButtonDropdown,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Label,
  Badge,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import BaseAPI from '../../api/apiurl.js';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup,Form, Button, CustomInput } from 'reactstrap';
// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import MUIDataTable from "mui-datatables";
import moreIcon from "../../assets/tables/moreIcon.svg"; //

import s from "../tables/Tables.module.scss";
import mock from "../tables/mock.js";
import { Projector } from "react-bootstrap-icons";
import SearchIcon from "../../components/Icons/HeaderIcons/SearchBarIcon.js";
const ServiceRescheduled = function () {


  const [firstTable] = useState(mock.firstTable);
  const [secondTable] = useState(mock.secondTable);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
  const [tableDropdownOpen, setTableMenuOpen] = useState(false); //
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const pageSize = 4;
const secondTablePagesCount = Math.ceil((data && data.length) ? data.length / pageSize : 0);
  const [sortOrder, setSortOrder] = useState('asc'); // or 'desc' for descending order
  const [sortedData, setSortedData] = useState([...data]);
  const [clickedImage, setClickedImage] = useState("");
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  


  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  } 

  const tableMenuOpen = () => {
    setTableMenuOpen(!tableDropdownOpen);
  } //


  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const toggleSortOrder = () => {
    setSortOrder(prevSortOrder => (prevSortOrder === 'asc' ? 'desc' : 'asc'));
  };

  const handleImageClick = (imageUrl) => {
    setClickedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const toggleImageModal = () => {
    setIsImageModalOpen(!isImageModalOpen);
  };

  const filteredData = data.filter(
    (item) =>
      item.serviceremarks.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.servicerefno.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.priority.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const fetchData = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');

    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }
    // const servicestatusString = servicestatus.map(option => option.value).join(',');

    const url = `${BaseAPI}servicefilters?company_id=${companyId}&customer_id=${customerId}&servicestatus=4`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.data && data.data.length > 0) {
          setData(data.data);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching data from API:', error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);
  const combinedData =  filteredData;
console.log('001' , data )
  return (
    <div>
      <Row>
        <Col>
          <Row className="mb-4">
            <Col>
              <Widget>
                <div className={s.tableTitle} >
                   <div className="headline-2" style={{color : "blue"}}>In-Progress View</div> 
                  <div className="mt-3 inputs">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={handleSearch} // Attach onChange event to update search term
                    />
                  </div>
                </div>
                <div className="widget-table-overflow">
                {data && data.length > 0 ? (
                          <div style={{
                            maxHeight: '500px',
                            overflowY: 'auto',
                          }} >
                 <Table className={`table-striped table-borderless table-hover`} responsive  style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ whiteSpace: 'nowrap' , width: '100%'}}>
                                  <th>Image</th>
                                  <th>Service No</th>
                                  <th>Request Description</th>
                                  <th>
                                    Priority 
                                  </th>
                                  <th>Product</th>
                                  <th>Register</th>
                                  <th>Desired</th>
                                  <th>Completed</th>
                                  <th>Status</th>

                                </tr>
                              </thead>
                              <tbody style={{ whiteSpace: 'nowrap', textAlign: "center", height: "10px" }}>
                                {combinedData
                                  .slice(secondTableCurrentPage * pageSize, (secondTableCurrentPage + 1) * pageSize)
                                  .map((item, index) => {

                                    const startRating = item.servicefdbkrating;

                                    return (
                                      
                                      <tr key={index}  style={{ whiteSpace: 'nowrap' , width: '100%'}}  >
                                         <td>
                                          <img src={`${item.serviceimg}`}
                                            alt="No Image"
                                            style={{ maxWidth: "80px", maxHeight: "40px" }}
                                            className="zoom-in-Qr"
                                            onClick={() => handleImageClick(item.serviceimg)}
                                          />
                                        </td>
                                        <td>{item.servicerefno}</td>
                                        <td style={{ overflow: 'auto' }}>
                                          <textarea
                                            value={item.servicedesc}
                                            rows={1}
                                            cols={20}
                                          />
                                        </td>

                                        <td>{item.priority}</td>
                                        <td>{item.productname}</td>
                                        {/* <td><StarRating rating={startRating} starClass="gold-star" /></td> */}
                                        <td>{item.regdate}</td>
                                        <td>{item.desireddate}</td>
                                        <td>{item.servicecompdate}</td>
                                        <td><Badge style={{
                                          backgroundColor:
                                            item.status === 'Registered' ? 'blue' :
                                              item.status === 'Assigned' ? 'deepskyblue' :
                                                item.status === 'Planned' ? 'brown' :
                                                  item.status === 'In-Progress' ? 'indigo' :
                                                    item.status === 'Resolved' ? 'transparent' :
                                                      item.status === 'Closed' ? 'Green' :
                                                        item.status === 'Re-Open' ? 'Yellow' :
                                                        item.status === 'Cancelled' ? 'gray' : 'black',
                                          color: item.status === 'Re-Open' ? 'black' : 'white',
                                        }}
                                        >
                                           {item.status}
                                         </Badge></td>

                                        {console.log("Service Image", item.serviceimg)}
                                      </tr>
                                    );
                                  })
                                }
                              </tbody>

                            </Table>
                           </div>
                            ) : (
                          <div colSpan="9" style={{ textAlign: "center", color: "red" }}>No data available</div>
                        )}
                  <Pagination className="pagination-with-border">
                    <PaginationItem disabled={secondTableCurrentPage <= 0}>
                      <PaginationLink
                        onClick={e => setSecondTablePage(e, secondTableCurrentPage - 1)}
                        previous
                        href="#top"
                      />
                    </PaginationItem>
                    {[...Array(secondTablePagesCount)].map((page, i) =>
                      <PaginationItem active={i === secondTableCurrentPage} key={i}>
                        <PaginationLink onClick={e => setSecondTablePage(e, i)} href="#top">
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    )}
                    <PaginationItem disabled={secondTableCurrentPage >= secondTablePagesCount - 1}>
                      <PaginationLink
                        onClick={e => setSecondTablePage(e, secondTableCurrentPage + 1)}
                        next
                        href="#top"
                      />
                    </PaginationItem>
                  </Pagination>
                </div>
              </Widget>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal isOpen={isImageModalOpen} toggle={toggleImageModal}>
        <ModalHeader toggle={toggleImageModal}>Image Preview</ModalHeader>
        <ModalBody>
          {clickedImage && (
            <img
              src={clickedImage}
              alt="View Image"
              style={{ maxWidth: "100%" }}
            />
          )}

        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={toggleImageModal}>
            Close
          </button>
        </ModalFooter>
      </Modal>

    </div>

    
  )
}

export default ServiceRescheduled;
